module.exports = __webpack_public_path__ + "img/taverna-d-el-rey.89135277.jpg";